const manifest = {
  ERC1967_PROXY: "ERC1967Proxy",
  SABLIER_COMPTROLLER: "SablierComptroller",
} as const;

export default manifest;
